/**
 * @generated SignedSource<<7f46995dc1b101a8f98ab1001d568858>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type ExternalMembershipType = "PRIVATE" | "PUBLIC" | "SHARED" | "%future added value";
export type SearchLinkedEntitiesType = "comments" | "messages" | "thread" | "%future added value";
export type SearchLinkedResultCategory = "child" | "mentionedBy" | "mentions" | "similar" | "%future added value";
export type SearchResultType = "ask" | "attachment" | "blogpost" | "board" | "comment" | "component" | "dashboard" | "database" | "document" | "embed" | "filter" | "focus_area" | "focus_area_status_update" | "folder" | "goal" | "goal_update" | "issue" | "learning" | "message" | "object" | "page" | "plan" | "position" | "presentation" | "project" | "project_update" | "question" | "repository" | "schema" | "slide" | "space" | "spreadsheet" | "tag" | "type" | "unrecognised" | "video" | "whiteboard" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type searchGraphMessage_AtlassianSearchPage$data = {
  readonly attachments: ReadonlyArray<{
    readonly __typename: "SearchResultGraphAttachment";
  }> | null | undefined;
  readonly entity: {
    readonly attachments?: ReadonlyArray<{
      readonly __typename: "ExternalAttachment";
    } | null | undefined> | null | undefined;
    readonly container?: {
      readonly id?: string;
      readonly memberCount?: AGG$Long | null | undefined;
      readonly membershipType?: ExternalMembershipType | null | undefined;
    } | null | undefined;
    readonly description?: string | null | undefined;
    readonly lastActive?: string | null | undefined;
    readonly reactionCount?: number | null | undefined;
  } | null | undefined;
  readonly excerpt: string | null | undefined;
  readonly id: string;
  readonly lastModifiedDate: string | null | undefined;
  readonly linkedEntities: ReadonlyArray<{
    readonly entity: {
      readonly description?: string | null | undefined;
    } | null | undefined;
    readonly excerpt: string | null | undefined;
  }> | null | undefined;
  readonly linkedEntitiesType: SearchLinkedEntitiesType | null | undefined;
  readonly linkedResults: ReadonlyArray<{
    readonly category: SearchLinkedResultCategory;
    readonly connectorType: string | null | undefined;
    readonly description: string;
    readonly id: string;
    readonly integrationId: string | null | undefined;
    readonly lastModifiedDate: string | null | undefined;
    readonly providerId: string | null | undefined;
    readonly subtype: string | null | undefined;
    readonly title: string;
    readonly type: SearchResultType;
    readonly url: string;
  }> | null | undefined;
  readonly links: ReadonlyArray<string> | null | undefined;
  readonly url: string;
  readonly " $fragmentSpreads": FragmentRefs<"attachmentItems_AtlassianSearchPage_DropdownItems" | "attachments_AtlassianSearchPage" | "threadBody_AtlassianSearchPage" | "threadTitle_AtlassianSearchPage">;
  readonly " $fragmentType": "searchGraphMessage_AtlassianSearchPage";
};
export type searchGraphMessage_AtlassianSearchPage$key = {
  readonly " $data"?: searchGraphMessage_AtlassianSearchPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"searchGraphMessage_AtlassianSearchPage">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
},
v1 = {
  "kind": "ScalarField",
  "name": "url"
},
v2 = {
  "kind": "ScalarField",
  "name": "excerpt"
},
v3 = [
  {
    "kind": "ScalarField",
    "name": "__typename"
  }
],
v4 = {
  "kind": "ScalarField",
  "name": "description"
},
v5 = {
  "kind": "ScalarField",
  "name": "lastModifiedDate"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "searchGraphMessage_AtlassianSearchPage",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "attachmentItems_AtlassianSearchPage_DropdownItems"
    },
    {
      "kind": "FragmentSpread",
      "name": "attachments_AtlassianSearchPage"
    },
    {
      "kind": "FragmentSpread",
      "name": "threadTitle_AtlassianSearchPage"
    },
    {
      "kind": "FragmentSpread",
      "name": "threadBody_AtlassianSearchPage"
    },
    (v0/*: any*/),
    (v1/*: any*/),
    (v2/*: any*/),
    {
      "kind": "ScalarField",
      "name": "links"
    },
    {
      "concreteType": "SearchResultGraphAttachment",
      "kind": "LinkedField",
      "name": "attachments",
      "plural": true,
      "selections": (v3/*: any*/)
    },
    {
      "concreteType": "SearchResultGraphDocument",
      "kind": "LinkedField",
      "name": "linkedEntities",
      "plural": true,
      "selections": [
        (v2/*: any*/),
        {
          "kind": "LinkedField",
          "name": "entity",
          "plural": false,
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": [
                (v4/*: any*/)
              ],
              "type": "ExternalMessage"
            }
          ]
        }
      ]
    },
    {
      "kind": "ScalarField",
      "name": "linkedEntitiesType"
    },
    (v5/*: any*/),
    {
      "kind": "LinkedField",
      "name": "entity",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "kind": "ScalarField",
              "name": "lastActive"
            },
            (v4/*: any*/),
            {
              "kind": "ScalarField",
              "name": "reactionCount"
            },
            {
              "concreteType": "ExternalAttachment",
              "kind": "LinkedField",
              "name": "attachments",
              "plural": true,
              "selections": (v3/*: any*/)
            },
            {
              "kind": "LinkedField",
              "name": "container",
              "plural": false,
              "selections": [
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v0/*: any*/),
                    {
                      "kind": "ScalarField",
                      "name": "memberCount"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "membershipType"
                    }
                  ],
                  "type": "ExternalConversation"
                }
              ]
            }
          ],
          "type": "ExternalMessage"
        }
      ]
    },
    {
      "concreteType": "SearchLinkedResult",
      "kind": "LinkedField",
      "name": "linkedResults",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "ScalarField",
          "name": "title"
        },
        (v1/*: any*/),
        {
          "kind": "ScalarField",
          "name": "type"
        },
        (v4/*: any*/),
        (v5/*: any*/),
        {
          "kind": "ScalarField",
          "name": "category"
        },
        {
          "kind": "ScalarField",
          "name": "subtype"
        },
        {
          "kind": "ScalarField",
          "name": "integrationId"
        },
        {
          "kind": "ScalarField",
          "name": "providerId"
        },
        {
          "kind": "ScalarField",
          "name": "connectorType"
        }
      ]
    }
  ],
  "type": "SearchResultGraphDocument"
};
})();

(node as any).hash = "df951b5e13a761dd66948ceaa86c4148";

export default node;
